import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { practitionerService } from '../../../services/practitionerService';

const DeleteConfirmModal = ({ practitioner, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    
    try {
      await practitionerService?.delete(practitioner?.id);
      onConfirm?.();
    } catch (err) {
      console.error('Error deleting practitioner:', err);
      setError(err?.message || 'Erreur lors de la suppression');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-2xl shadow-2xl border border-white/8 max-w-md w-full">
        {/* Header */}
        <div className="px-6 py-4 border-b border-white/8">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 bg-error-bg rounded-xl">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-primary">Confirmer la suppression</h2>
              <p className="text-sm text-muted">Cette action est irréversible</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {error && (
            <div className="bg-error-bg border border-error/30 rounded-xl p-4 flex items-start gap-3">
              <Icon name="AlertCircle" size={20} className="text-error flex-shrink-0 mt-0.5" />
              <p className="text-sm text-secondary">{error}</p>
            </div>
          )}

          <p className="text-secondary">
            Êtes-vous sûr de vouloir supprimer le praticien suivant ?
          </p>

          <div className="bg-card-elevated rounded-xl p-4 space-y-2 border border-white/8">
            <div>
              <p className="text-sm text-muted">Cabinet</p>
              <p className="font-medium text-primary">{practitioner?.practiceName}</p>
            </div>
            <div>
              <p className="text-sm text-muted">Praticien</p>
              <p className="font-medium text-primary">
                {practitioner?.practitionerTitle} {practitioner?.practitionerName}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted">Email</p>
              <p className="font-medium text-primary">{practitioner?.email}</p>
            </div>
          </div>

          <div className="bg-warning-bg border border-warning/30 rounded-xl p-4">
            <p className="text-sm text-secondary">
              <strong className="text-warning">Attention :</strong> Tous les référals associés à ce praticien seront également supprimés.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="px-6 py-4 bg-card-elevated rounded-b-2xl flex items-center justify-end gap-3 border-t border-white/8">
          <Button
            onClick={onClose}
            className="px-6 py-2 text-secondary hover:bg-card-hover rounded-xl font-medium transition-colors"
            disabled={loading}
          >
            Annuler
          </Button>
          <Button
            onClick={handleDelete}
            className="px-6 py-2 bg-error hover:bg-error/90 text-white rounded-xl font-medium transition-colors flex items-center gap-2 shadow-lg"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Suppression...</span>
              </>
            ) : (
              <>
                <Icon name="Trash2" size={18} />
                <span>Supprimer</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;